import { getNetwork } from '../utils/getNetwork';
import { API_AUTH } from '../config';

export const fetchCurrentUser = () => getNetwork().get(API_AUTH + '/users/current');